<template>
    <div>
        <el-row :gutter="24"  :key="o">
            <el-col :span="24"><div class="grid-content bg-purple">
                <el-card :body-style="{ left: '0px' }" shadow="hover">
                    <el-header :style="{'font-size': '20px',left: '0%','position': 'relative'}">
                        密码登录

                    </el-header>
<!--                    :style="{'height':'15px'}"-->
<!--                    <div slot="header"  :style="{'height':'15px','position': 'relative','padding-top': '0px','display': 'flex'}">-->
<!--                       密码登录-->
<!--            </div>-->

                    <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm":style="{'left':'0px'}">
                        <el-form-item label="" prop="userAccount">
                            <el-input v-model.number="ruleForm.userAccount" placeholder="请输入账号:" prefix-icon="el-icon-user"></el-input>
                        </el-form-item>

                        <el-form-item label="" prop="pass">
                            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码:" prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div></el-col>

        </el-row>




    </div>
</template>

<script>
    import {wordLogin} from "../network/recitewords";

    export default {
        name: "Loginform",
        data() {
            var checkAccount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('账号不能为空'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if (value < 18) {
                            callback(new Error('账号长度必须大于2'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };


            return {
                ruleForm: {
                    userAccount: '',
                    pass: '',

                },
                rules: {
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    userAccount: [
                        { validator: checkAccount, trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$emit('loginSuccess',this.ruleForm);
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
.fs{
    position: relative;
    padding-top: 0px;
    display: flex;
}
</style>